export default {"src":"/_next/static/media/google-play-logo.2718b678.svg","height":23,"width":21,"blurWidth":0,"blurHeight":0};